(function () {
  function initShopByCollections(root) {
    if (!root || root.dataset.sbcReady === 'true') return;
    root.dataset.sbcReady = 'true';

    const tablist = root.querySelector('[data-sbc-tablist]');
    const tabs = Array.from(root.querySelectorAll('[data-sbc-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-sbc-panel]'));
    const indicator = root.querySelector('[data-sbc-tab-indicator]');

    if (!tablist || !tabs.length || !panels.length) return;

    function moveTabIndicator(tab, animate) {
      if (!indicator || !tab) return;

      const tablistRect = tablist.getBoundingClientRect();
      const tabRect = tab.getBoundingClientRect();
      const left = tabRect.left - tablistRect.left;
      const width = tabRect.width;

      if (animate === false) {
        indicator.style.transition = 'none';
      }

      indicator.style.width = width + 'px';
      indicator.style.transform = 'translateX(' + left + 'px)';

      if (animate === false) {
        indicator.offsetHeight;
        indicator.style.transition = '';
      }
    }

    function activateTab(panelId, animateIndicator) {
      let activeTab = null;

      tabs.forEach(function (tab) {
        const isActive = tab.getAttribute('data-sbc-tab') === panelId;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
        if (isActive) activeTab = tab;
      });

      panels.forEach(function (panel) {
        const isActive = panel.getAttribute('data-sbc-panel') === panelId;
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      moveTabIndicator(activeTab, animateIndicator !== false);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab.getAttribute('data-sbc-tab'), true);
      });

      tab.addEventListener('keydown', function (event) {
        const currentIndex = tabs.indexOf(tab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (currentIndex + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        tabs[nextIndex].focus();
        activateTab(tabs[nextIndex].getAttribute('data-sbc-tab'), true);
      });
    });

    window.addEventListener('resize', function () {
      const activeTab =
        tabs.find(function (tab) {
          return tab.getAttribute('aria-selected') === 'true';
        }) || tabs[0];
      moveTabIndicator(activeTab, false);
    });

    const initial =
      tabs.find(function (tab) {
        return tab.classList.contains('is-active');
      }) || tabs[0];
    activateTab(initial.getAttribute('data-sbc-tab'), false);
  }

  function initAll() {
    document.querySelectorAll('[data-sbc]').forEach(initShopByCollections);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('[data-sbc]');
    if (section) {
      section.dataset.sbcReady = 'false';
      initShopByCollections(section);
    }
  });
})();
